import React from "react";
import KpiCard from "./KpiCard";
import { RULE_GROUPS, RULE_GROUP_META } from "../../domain/inconsistencyRules";

const GROUP_ORDER = [
  RULE_GROUPS.TASK,
  RULE_GROUPS.DOCUMENT,
  RULE_GROUPS.SPRINT,
  RULE_GROUPS.PROJECT,
];

const TOTAL_HINT = "Soma de todas as regras apuradas";

// O esqueleto substitui o card inteiro: um bloco por indicador, na mesma
// caixa que o card vai ocupar depois.
function KpiStripSkeleton() {
  return (
    <div className="kpis" aria-hidden="true">
      {["total"].concat(GROUP_ORDER).map((group) => (
        <div className="skel kpi-skel" key={group} />
      ))}
    </div>
  );
}

function KpiStrip({ summary, loading }) {
  if (loading) {
    return <KpiStripSkeleton />;
  }

  return (
    <div className="kpis">
      <KpiCard
        testId="kpi-total"
        label="Total"
        count={summary.total}
        hint={TOTAL_HINT}
        highlight
      />
      {GROUP_ORDER.map((group) => (
        <KpiCard
          key={group}
          testId={`kpi-${group}`}
          label={RULE_GROUP_META[group].label}
          count={summary.byGroup[group]}
          hint={RULE_GROUP_META[group].description}
        />
      ))}
    </div>
  );
}

export default KpiStrip;
